import { IQuestionModel } from '@care-portals/api-interfaces';

const antiAgingBelugaFollowupQuestions: IQuestionModel[] = [
  {
    class: 'ineligible',
    field: 'antiAgingBelugaFollowup_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    type: 'info',
    isLast: true,
    reject: true,
    extras: { sendToBeluga: false },
    answer: {}
  },

  {
    class: 'ineligible',
    field: 'antiAgingBelugaFollowup_didNotConsent',
    label: 'We need your consent to continue',
    subLabel:
      'You did not agree to the terms shown on the previous step. Without that consent, we cannot move forward with your visit or prescribe treatment.',
    type: 'info',
    isLast: true,
    reject: true,
    answer: {},
    extras: { sendToBeluga: false }
  },
  {
    field: 'antiAgingBelugaFollowup_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    label: 'What was your sex assigned at birth?',
    field: 'antiAgingBelugaFollowup_sexAssignedAtBirth',
    extras: {
      sendToBeluga: false
    },
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'antiAgingBelugaFollowup_sexAssignedAtBirth_male',
          value: 'Male'
        },
        {
          key: 'antiAgingBelugaFollowup_sexAssignedAtBirth_female',
          value: 'Female'
        }
      ]
    }
  },
  {
    label: 'What is your height in feet and inches?',
    field: 'antiAgingBelugaFollowup_height',
    type: 'info',
    answer: {
      name: 'antiAgingBelugaFollowup_height',
      type: 'text',
      placeholder: 'Feet and inches'
    }
  },
  {
    label: 'What is your weight in pounds?',
    field: 'antiAgingBelugaFollowup_weight',
    type: 'info',
    answer: {
      name: 'antiAgingBelugaFollowup_weight',
      type: 'text',
      placeholder: 'Pounds'
    }
  },
  {
    label:
      'Have there been any health changes, medication changes, ED visits or hospitalizations since your last check-in?',
    field: 'antiAgingBelugaFollowup_healthChanges',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'antiAgingBelugaFollowup_healthChanges_yes',
          value: 'Yes'
        },
        {
          key: 'antiAgingBelugaFollowup_healthChanges_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about the changes in your health',
    field: 'antiAgingBelugaFollowup_healthChangesDetails',
    type: 'info',
    answer: {
      name: 'antiAgingBelugaFollowup_healthChangesDetails',
      type: 'text',
      placeholder: 'Describe your health changes'
    }
  },
  {
    label: 'How are you doing on the current medication?',
    field: 'antiAgingBelugaFollowup_medicationExperience',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'antiAgingBelugaFollowup_medicationExperience_well',
          value: 'Well'
        },
        {
          key: 'antiAgingBelugaFollowup_medicationExperience_notWell',
          value: 'Not well'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about what you are experiencing',
    field: 'antiAgingBelugaFollowup_medicationExperienceDetails',
    type: 'info',
    answer: {
      name: 'antiAgingBelugaFollowup_medicationExperienceDetails',
      type: 'text',
      placeholder: 'Describe your experience'
    }
  },
  {
    label: 'Have you had any side effects from the current medication?',
    field: 'antiAgingBelugaFollowup_sideEffects',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'antiAgingBelugaFollowup_sideEffects_yes',
          value: 'Yes'
        },
        {
          key: 'antiAgingBelugaFollowup_sideEffects_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about the side effects you are experiencing',
    field: 'antiAgingBelugaFollowup_sideEffectsDetails',
    type: 'info',
    answer: {
      name: 'antiAgingBelugaFollowup_sideEffectsDetails',
      type: 'text',
      placeholder: 'Describe the side effects'
    }
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'antiAgingBelugaFollowup_additionalInfo',
    type: 'info',
    answer: {
      name: 'antiAgingBelugaFollowup_additionalInfo',
      type: 'text',
      placeholder: 'Additional information or questions'
    }
  },
  {
    label: 'Consent (Informed Consent Statement)',
    educationalSlide: `Please read the following regarding safety information regarding this product. The products referenced—Glutathione, Metformin, and/or NAD+—are intended solely for lifestyle enhancement and are not approved by the U.S. Food and Drug Administration (FDA). This means that they have not undergone the FDA's rigorous evaluation process to verify their safety, effectiveness, or quality for treating or preventing any medical conditions. These products are not designed to diagnose, treat, cure, or prevent any disease, and individual results may vary.

Purpose of This Consent Form
The purpose of this consent form is to ensure that you understand:
- The reasons for using these products
- The potential benefits and risks
- The monitoring plan
- Your responsibilities during treatment

Background Information
Nicotinamide Adenine Dinucleotide (NAD) and Glutathione are essential substances naturally found in your body that play critical roles in maintaining health and cellular function.
NAD and Glutathione: Together, NAD and glutathione help to maintain cellular health, boost energy levels, and protect the body from potential harm.
Metformin: Commonly used for managing diabetes, metformin has shown potential anti-aging benefits. It works by:
  - Improving cellular metabolism and reducing oxidative stress
  - Enhancing insulin sensitivity, which helps lower blood sugar and reduces inflammation
  - Activating AMPK (adenosine monophosphate-activated protein kinase), an enzyme involved in cellular energy regulation, promoting longevity and healthy aging

Off-Label Use Notice
The use of these products for anti-aging purposes is considered off-label. While they may be legally prescribed, they are not FDA-approved for the treatment of disease and are intended solely for health and wellness purposes.

Potential Benefits
The potential benefits of these therapies include:
- Anti-aging effects
- Improved cellular health and energy levels
- Reduced risk of age-related diseases

Potential Risks and Side Effects
While these products may offer health benefits, side effects may occur:
NAD Therapy:
  - Common side effects: nausea, headaches, fatigue, abdominal cramping, flushing, dizziness
  - Injection site reactions: pain or swelling
  - Less common: muscle cramps, anxiety, and sweating
Glutathione Therapy:
  - Common side effects: gastrointestinal discomfort, headaches, skin reactions (e.g., rashes, itching)
  - Rare but possible: allergic reactions, skin lightening
Metformin:
  - Common side effects: gastrointestinal upset
  - Rare but serious: lactic acidosis
  - Long-term use may lead to vitamin B12 deficiency

Monitoring Plan
To ensure safety and effectiveness, regular monitoring will be required:
- Symptom Assessments: Periodic evaluations to gauge improvement
- Follow-Up Visits: Opportunities to discuss progress, side effects, and potential treatment adjustments
- Alternative Treatments: Patients may discuss options such as lifestyle changes in exercise, diet, and stress management

Patient Responsibilities
As a patient, you are responsible for:
- Attending all scheduled follow-up appointments
- Reporting any side effects or new symptoms
- Adhering to the prescribed dosage without making independent changes

Patient Acknowledgment and Consent
- I have read and understood the information provided in this consent form.
- I understand the potential risks and benefits of using this product and the off-label nature of this treatment.
- I agree to adhere to the monitoring plan and to inform my healthcare provider of any side effects or concerns.

By selecting below, I voluntarily consent to the use of this product for the treatment of my symptoms.`,
    field: 'antiAgingBelugaFollowup_consent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'antiAgingBelugaFollowup_consent_disagree',
          class: 'option-decline',
          value:
            'I have read the above information and I do not wish to continue'
        },
        {
          key: 'antiAgingBelugaFollowup_consent_agree',
          class: 'option-consent',
          value:
            'I have read the above information, I understand the risks and would like to proceed'
        }
      ]
    }
  }
];

export default antiAgingBelugaFollowupQuestions;

